import { Component, OnInit, ChangeDetectorRef, HostListener, IterableDiffers, ViewChild, ViewChildren, QueryList, ElementRef, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '../../../components/utils/constants';
import { AsyncPipe, CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { environment } from '../../../../environments/environment'
import { BankProfile } from '../../../components/utils/bank-profile';
import { HttpService } from '../../../components/service/http.service';
import { BankDetailService } from '../../../components/service/bank-detail.service';
import { TruckAccountInfo } from '../../../components/utils/truck-account-info';
import { PaymentPayload } from '../../../components/utils/payload';
import { Payment } from '../../../components/utils/payment';
import { AuthorizationService } from '../../authorization/authorization.service';
import { ContractNumberRequest } from '../../../shared/models/contractNumberResponse';
import { AssetListResponse } from '../../../shared/models/assetListResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { AccoutDetailsResponse } from '../../../shared/models/accountDetailsResponse';
import { PayoffResponseBeanList } from '../../../shared/payoffResponseBeanList';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { DTFHomepageService } from '../../dtfhomepage/dtfhomepage.service';
import { Banner } from '../../../shared/models/banner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { PayComponent } from '../../pay/pay.component';
import {MatIconModule} from '@angular/material/icon';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import { monthlypaymentResponseList } from '../../../shared/models/monthlypaymentResponseList';
import { principalPaymentResponseList } from '../../../shared/models/principalPaymentResponseList';
import { PayCopyComponent } from '../../pay copy/paycopy.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'jspdf-autotable';
import { TranslateService } from '@ngx-translate/core';
import { WindowRef } from '../../../utils/window';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressRequest } from '../../../shared/models/AddressRequest';
import { VertexAddressResponse } from '../../../shared/models/VertexAddressResponse';
import { VertexPostalAddress } from '../../../shared/models/VertexPostalAddress';
import { TranslateUtil } from '../../../utils/translate-util';
import { monthlypaymentRequestlist } from '../../../../../src/app/shared/models/monthlypaymentRequestlist';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { executionInterval } from '../../../../../src/app/shared/models/executionInterval';
import { SubscriptionResponseList } from '../../../../../src/app/shared/models/SubscriptionResponseList';
import { PaymentPostedList } from '../../../../../src/app/shared/models/PaymentPostedList';
import { Console } from 'console';
import { Daum } from '../../../../../src/app/shared/models/Daum';
import { SessionTimeoutComponent } from '../../sessionTimeout/sessionTimeout.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';


interface Requests {
  value: string;
  viewValue: string;
}

interface Payments {
  value: string;
  viewValue: string;
}

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-onlinepayment',
    templateUrl: './onlinepayment.component.html',
    styles: [],
    providers: [provideNativeDateAdapter(), provideNgxMask()],
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatIconModule, MatSortModule, MatPaginatorModule, MatDialogModule,
        MatButtonModule, NgxMaskDirective, NgxMaskPipe
    ]
})
export class OnlinepaymentComponent {
  
  bankDetailObj: BankProfile = new BankProfile;
  selected: any;
  profiles: any;
  loaded: boolean;
  currentDatePayoff = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
  accountData: TruckAccountInfo[];
  onePaymentBoolean: boolean;
  wrongDate: boolean;
  amountLimit: boolean;
  emptyAmount: boolean;
  emptyDate: boolean;
  page: string;
  userAccountInfo: any
  agentView: boolean
  blocked: boolean;
  errmsg: any;
  tableLoaded = true;
  getAgreementAssetDetailRequest: any = {};
 
  ciamId = sessionStorage.getItem('loginID');
  getMultiPayoffRequest: any = {};
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  terminationDate = '';
  brandId: string;
  assetListRes: AssetListResponse[];
  isFrench = false;
  language = '';
  displaycontractNumberList = '';
  titleAuthNumberList: ContractNumberRequest[];
  token: string;
  accountDetailsRes: AccoutDetailsResponse[];
  rowCount = 0;
  isdropdown = true;
  isdropdownPr = true;
  showtextbox = false;
  monthlypayment = true;
  monthlypaymentstep1 = true;
  OnlinePaymentstep1 = true;
  monthlypaymentstep2 = false;
  monthlypaymentstep3 = false;
  principalpayment = false;
  principalpaymentstep1 = false;
  principalpaymentstep2 = false;
  principalpaymentstep3 = false;
  invalid: boolean=false;
  invalidPr: boolean=false;
  currentCountry: string;
  public alerts: Banner;
  dbData: any;
  langFlag: string;
  countryFlag: string;
  bodyLoaded = false;
  search = false;
  ifdown = false;
  ifup = true;
  searchtwo = false;
  ifuptwo= true;
  ifdowntwo= false;
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
  thirdParty: string;
  MonthlyPaymentResponseList: monthlypaymentResponseList[];
  PrincipalPaymentResponseList: principalPaymentResponseList[];
  accountSelected = false;
  selectedMonthlyResponseList:monthlypaymentResponseList[];
  selectedPrincipalResponseList:principalPaymentResponseList[];
  isChecked = false;
  customerName: string;
  usUrl: string;
  caUrl: string;
  totalAmount: number = 0;
  totalAmountPr: number = 0;
  amount1: string;  // Amount entered by the user
  isAmountEntered: boolean = false;  // Flag to control div visibility
  contractSelected = false;
  azURL: string;
  trans_history = false;
  required = false;
  amount = false;
  error = false;
  amountPayoff: number = 0;
  selectone = false;
  currentDate: { [agreementNumber: string]: Date } = {};
  payoffstep2 = false;
  payoffstep3 = false;
  selectedPayment: string | null = null;
  currentDates: Date;
  dtpayCustomerId: String = "";
  dtpayMaskedAccountNumber: String = "";
  dtpayPaymentMethodToken: String = '';
  lineitemsList: monthlypaymentRequestlist;
  line_items: monthlypaymentRequestlist[];
  reference: string;
  status: string;
  selectAcc: string;
  quoteamount: string;
  quoteNumber: string;
  paymentDate: string;
  executionInterval: executionInterval;
  exec_Interval: executionInterval[];
  subscriptionResponseList: SubscriptionResponseList[];
  paymentPostedList: PaymentPostedList[];
  subscriptionList: Daum[];
  warningMessage: string = '';
  showWarning = false;
  agreementsWithSubscription: string[] = [];
  failureError = false;
  baseRedirect = '';
  paymentLineItem: string;

  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];

  payoffResponseBeanList: PayoffResponseBeanList[];
  payOffObj : PayoffResponseBeanList;
  payoff = false;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  dropDownList: Array<any>=[];
  saveProfileFalse: String;
  agentview: string;
 
  initColumns: any[] = [
    {
      name: 'accountNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'paymentAmount',
      display: 'Payment Amount',
      dispFormat: 'currentamountdue'
    },
    {
      name: 'paymentDate',
      display: 'Payment Date',
      dispFormat: 'date1'
    },
    {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  initMonthlyPaymentColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'nextPaymentDue',
      display: 'Monthly Payment',
      dispFormat: 'currency'
    },
    {
      name: 'currentDueDate',
      display: 'Due Date',
      dispFormat: 'date'
    },
    {
      name: 'currentDate[element.agreementNumber]',
      display: 'Payment Date',
      dispFormat: 'date1'
    },
    {
      name: 'totalAmountDue',
      display: 'Current Amount Due',
      dispFormat: 'currentamountdue'
    }
  ];
  displayedMonthlyPaymentColumns: any[] = this.initMonthlyPaymentColumns.map(col => col.name);

  initMonthlyPaymentColumnsStep2: any[] = [
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'totalAmountDue',
      display: 'Current Amount Due',
      dispFormat: 'currentamountdue'
    },
    {
      name: 'nextPaymentDue',
      display: 'Monthly Payment',
      dispFormat: 'currency'
    },
    {
      name: 'paymentDate',
      display: 'Payment Date',
      dispFormat: 'date1'
    },
    {
      name: 'currentDueDate',
      display: 'Due Date',
      dispFormat: 'date'
    },
  ];
  displayedMonthlyPaymentColumnsStep2: any[] = this.initMonthlyPaymentColumnsStep2.map(col => col.name);

  initPayoffColumns: any[] = [
    {
      name: 'contractNumber',
      display: 'Account Number',
      dispFormat: ''
    },
    {
      name: 'quoteAmount',
      display: 'Payoff Amount',
      dispFormat: 'amt'
    },
    {
      name: 'date',
      display: 'Payment Date',
      dispFormat: 'date'
    },
    {
      name: 'transaction',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedPayoffColumns: any[] = this.initPayoffColumns.map(col => col.name);

  initPayoffColumns2: any[] = [
    {
      name: 'contractNumber',
      display: 'Account Number',
      dispFormat: ''
    },
    {
      name: 'quoteAmount',
      display: 'Payoff Amount',
      dispFormat: 'amt'
    },
    {
      name: 'date',
      display: 'Payment Date',
      dispFormat: 'date'
    }
  ];
  displayedPayoffColumns2: any[] = this.initPayoffColumns2.map(col => col.name);
 
  selection = new SelectionModel<monthlypaymentResponseList>(true, []);
  dataSource: MatTableDataSource<monthlypaymentResponseList>;
  paymentdataSource: MatTableDataSource<PaymentPostedList>;
  pipe: DatePipe;
  multipayoffdataSource: MatTableDataSource<PayoffResponseBeanList>;
  HistoricalSubscriptionDataSource: MatTableDataSource<Daum>;
  // payoffResponseBean: PayoffResponseBeanList

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  



  constructor(private router: Router, private _window: WindowRef, private cdr: ChangeDetectorRef, private httpService: HttpService, private bankDetailService: BankDetailService, public auth: AuthorizationService,private dtfhomepageService: DTFHomepageService, public translate: TranslateService, public dialog: MatDialog) {
    router: Router
    this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
    this.MonthlyPaymentResponseList = [];
    this.line_items = [];
    this.exec_Interval = [];
    this.subscriptionResponseList = [];
    this.paymentPostedList=[];
    this.dataSource = new MatTableDataSource(this.MonthlyPaymentResponseList);
    this.paymentdataSource = new MatTableDataSource(this.paymentPostedList);
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.currentDates = new Date();
    this.minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  }


 

  ngOnInit(): void {
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.customerName = sessionStorage.getItem('customerName');
    this.saveProfileFalse = sessionStorage.getItem('saveProfileFasleObj');
    this.paymentLineItem = sessionStorage.getItem('paymentLineItem');
    this.onLoad();
    this.checkPaymentType();
    // if (sessionStorage.getItem('agentView') == "true") {
    //   this.agentView = true
    // } else {
    //   this.agentView = false
    // }
    this.agentview = sessionStorage.getItem('agentview');
    this.page = sessionStorage.getItem('page')
    //  this.validateUser()
    // this.getBankProfile()
  
    //this.dtf_Url=environment.dtf_Url
    this.isFrench = ('fr-CA' === this.language) ? true : false;
    this.token = sessionStorage.getItem('ciamToken');
   
    this.accounts();
    this.calculateTotalAmount();
    
    this.langInit();
    
  }

   langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  //bank profiles dropdown
  onLoad() {
    this.dropDownList = [];
    const request = {
      "thirdPartyId": this.thirdParty,
      "userId": this.ciamId
    }

    let profileFromSession = sessionStorage.getItem('saveProfileFasleObj');

    if (profileFromSession) {
      // Set userExist to false in sessionStorage
      sessionStorage.setItem('userExist', "false");
      let obj = JSON.parse(profileFromSession);
      obj.id = "1";
    
    
      if (Array.isArray(this.profiles)) {
        this.profiles.unshift(obj);  
      } else {
       
        this.profiles = [obj];
      }

      this.profiles.forEach((element: any) => {
        let option = element.bankName + " " + (element.acctNum ? element.acctNum.substr(element.acctNum.length - 4) : 'XXXX');
        let obj = { selection: option, id: element.id };
        this.dropDownList.push(obj);
        this.selected = this.dropDownList[0]["id"];
      });
      this.dtpayCustomerId = sessionStorage.getItem('dtpaycustomerid');
      this.dtpayPaymentMethodToken = sessionStorage.getItem('dtpaypaymentmethodtoken');
      this.dtpayMaskedAccountNumber= sessionStorage.getItem('dtpayMaskedAccountNumber');
      
      sessionStorage.removeItem('saveProfileFasleObj');
      this.bankDetailObj = this.profiles[0];
      this.bankDetailService.setObject(this.bankDetailObj);
      
      this.loaded = true;
    } 
    else {
    this.auth.bankProfile(request).subscribe(res => {
      if (res.length == 0) {
        sessionStorage.setItem('online-page-navigation', "Online-Payment")
        sessionStorage.setItem('userExist', "true")
        this.router.navigate(['/home/addprofile']);
      } else {
        sessionStorage.setItem('page', '');
        sessionStorage.setItem('userExist', "false")
        this.profiles = res;

        this.profiles.forEach((element: any) => {
          let option = element.bankName + " " + element.maskedAccountNumber.substr(element.maskedAccountNumber.length - 4)
          let obj = { selection: option, id: element.id }
          this.dropDownList.push(obj);
          this.selected = this.dropDownList[0]["id"];
        })

        this.bankDetailObj = this.profiles[0];
        this.bankDetailService.setObject(this.bankDetailObj);
        this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
        this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
        this.dtpayMaskedAccountNumber=this.bankDetailObj.maskedAccountNumber;
        this.loaded = true;

        this.subscriptionsList();

      }

    }, error => {
      if (error.status) {
        this.errmsg = error.message
        this.blocked = true;
        this.loaded = true;
      }
    });
  }
  }
 
    onChange(){
      let index=this.profiles.findIndex((obj:any)=>obj.id===this.selected)
      this.bankDetailObj=this.profiles[index];
      this.bankDetailService.setObject(this.bankDetailObj);
      
      this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
      this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
      console.log("dtpayCustomerId",this.dtpayCustomerId);
      console.log("dtpayPaymentMethodToken",this.dtpayPaymentMethodToken);
    }

    getSelectedBankName(): string {
      const selectedBank = this.dropDownList.find(opt => opt.id === this.selected);
      return selectedBank ? selectedBank.selection : '';  // Return the bank name or an empty string if not found
    }

  accounts() {
    this.tableLoaded = false;
    const thirdpartyRequest = {
      "thirdPartyNumber": this.thirdParty,
      "brandId":2,
      "ciamId":this.ciamId
    };
  
    this.auth.getODSThirdPartyAccountSummary(thirdpartyRequest).subscribe(res => {
      this.MonthlyPaymentResponseList = [];
      this.MonthlyPaymentResponseList = res;
      const today = new Date();
      for (var i = 0; i < this.MonthlyPaymentResponseList.length; i++) {
        let totalAmountDue = parseFloat(this.MonthlyPaymentResponseList[i].totalAmountDue);

        // Ensure negative values are set to 0.00
        if (totalAmountDue < 0) {
          this.MonthlyPaymentResponseList[i].totalAmountDue = "0.00";
        } else {
          // Format the value if it's a positive amount
          this.MonthlyPaymentResponseList[i].totalAmountDue = totalAmountDue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }

        let daysPastDue = parseInt(this.MonthlyPaymentResponseList[i].daysPastDue);
        if (isNaN(daysPastDue) || daysPastDue < 0) {
          daysPastDue = 0;
        }

        let remainingDays = 60 - daysPastDue;
        if (remainingDays < 0) remainingDays = 0;

        const maxAllowedDate = new Date(today);
        maxAllowedDate.setDate(today.getDate() + remainingDays);

        const contractEndDate = new Date(this.MonthlyPaymentResponseList[i].endDate);
        
        // Extract year, month, and day
        const year = contractEndDate.getFullYear();
        const month = contractEndDate.getMonth();  // Note: zero-based month (0 = January)
        const day = contractEndDate.getDate();

        // Create new Date object with time set to midnight
        const formattedDate = new Date(year, month, day);

        if (formattedDate <= maxAllowedDate) {
          this.maxDate[this.MonthlyPaymentResponseList[i].agreementNumber] = contractEndDate;
        } else {
          this.maxDate[this.MonthlyPaymentResponseList[i].agreementNumber] = maxAllowedDate;
        }

        this.currentDate[this.MonthlyPaymentResponseList[i].agreementNumber] = new Date();

        this.MonthlyPaymentResponseList.forEach(contract => { this.currentDate[contract.agreementNumber] = new Date();})
      }

      this.dataSource = new MatTableDataSource(this.MonthlyPaymentResponseList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.tableLoaded = true;
      this.calculateTotalAmount();
   });
  }

  checkPaymentType(){
    if(sessionStorage.getItem('page')=="payoff_quote"){
      this.monthlypayment = false;
      this.payoff = true;
      this.monthlypaymentstep1 = false;
      this.OnlinePaymentstep1 = false;
      this.quoteamount=sessionStorage.getItem('amount');
      this.selectAcc=sessionStorage.getItem('selectedAcct');
      this.quoteNumber=sessionStorage.getItem('quoteNumber');
      this.payOffObj = new PayoffResponseBeanList;
      this.payoffResponseBeanList=[];
      // PayoffResponseBean obj  = new PayoffResponseBean;
      this.payOffObj.quoteAmount=this.quoteamount;
      this.payOffObj.contractNumber = this.selectAcc;
      this.payoffResponseBeanList.push(this.payOffObj);

      this.amountPayoff = parseFloat(parseFloat(this.quoteamount).toFixed(2));
      this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
      this.multipayoffdataSource.paginator = this.paginator;
      this.multipayoffdataSource.sort = this.sort;
    }
  }


  onSubmitPayoff(){
    let quoteamount = parseFloat(this.quoteamount);
    if (quoteamount === 0 || quoteamount > 2000000) {
      this.error = true;
      this.amount = true;
    } 
    if(this.selected && !this.error){
    this.error = false;
    this.required = false;
    this.payoff = false;
    this.payoffstep3 = false;
    this.payoffstep2 = true;
    this.OnlinePaymentstep1 = false;
    this.monthlypayment = false;
    this.monthlypaymentstep1 = false;
    this.monthlypaymentstep2 = false;
    this.principalpaymentstep2 = false;
    console.log("dtpayCustomerIdpayoff",this.dtpayCustomerId);
    console.log("dtpayPaymentMethodTokenpayoff",this.dtpayPaymentMethodToken);
    }else{
      this.error = true;
      this.required = true;
    }
  }

  PayoffAuthorize(){
    this.opendialog1();
  }

  opendialog1(){
    const dialogRef = this.dialog.open(AuthorizeDialogComponent, {
      data: { amount1: this.amountPayoff }  
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {       
          this.isAmountEntered = true;
          this.payoff = false;
          this.payoffstep2 = false;
          this.payoffstep3 = true;
          this.OnlinePaymentstep1 = false;
          this.monthlypayment = false;
          this.monthlypaymentstep1 = false;
          this.monthlypaymentstep2 = false;
          this.monthlypaymentstep3 = false;
          this.principalpaymentstep2 = false; 

          this.tableLoaded = false;  

        this.checkPaymentType();
        console.log(this.payoffResponseBeanList);
      

        const request = {
          userId: this.ciamId,
          maskedAccountNumber: this.dtpayMaskedAccountNumber,
          "customer_id": this.dtpayCustomerId,
          "payment_type": "PAYOFF",
          "payment_settings": {
          "payment_method": {
            "token": this.dtpayPaymentMethodToken,
            "type": "FIRST_PAYMENT"   
          }
          },
          "line_items": [
            {
              "position": 1,
              "dollarAmount": parseFloat(this.quoteamount),
              "alfa_agreement_number": this.selectAcc,
              "payoff_termination_number": this.quoteNumber
            }
          ]
          
        }

        console.log("Monthly Payment Request",request);

        this.auth.orders(request).subscribe(res => {
          if(res.statusMessage === "FAILURE"){
            this.failureError = true;
          }
          console.log("Payment Response",res);
            this.reference = res?.[0]?.reference;
            this.paymentDate = res?.[0]?.created_at;
          //this.status =  res?.payment?.status === "COMPLETED" ? "COMPLETED": res?.payment?.status === "FAILED" ? "FAILED": "IN PROCESS"

          const paymentStatus = res?.payment?.status;

          if (paymentStatus === "COMPLETED") {
            this.status = "COMPLETED";
          } else if (paymentStatus === "FAILED") {
            const failureMessage =
              res?.payment?.transactions?.[0]?.failure_reasons?.[0]?.message;

            const extractedReason = failureMessage?.split("responseMessage:")?.[1]?.trim();

            this.status = extractedReason
              ? `FAILED (${extractedReason})`
              : "FAILED";
          } else {
            this.status = "IN PROCESS";
          }
          
          console.log("Reference ID",this.reference);
          console.log("Status",this.status);

          if(res){
            this.tableLoaded = true; 
          }
        });
      }
    });
  }

  scheduledpayment(){
    this._window.nativeWindow.location.href = '/home/scheduledpayment';
  }
  

  calculateTotalAmount(): void {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
    this.totalAmount = 0;
   }else {
    this.totalAmount = 0;
    for(var i = 0; i < this.selection.selected.length; i++ ){
    this.selection.selected[i].totalAmountDue = this.selection.selected[i].totalAmountDue.replace(/[^0-9.-]+/g, '');
    this.totalAmount += parseFloat(this.selection.selected[i].totalAmountDue);  
    }
    this.totalAmount = parseFloat(this.totalAmount.toFixed(2));
  }
   
  }
 
  positiveNumberOnly(event): boolean {

    const pattern = /[0-9.,]/;  // Allow only digits, comma, and decimal point
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }

    const charCode = (event.which) ? event.which : event.keyCode;
    if(charCode == 45)
      return false;
      return true;

     
  }

 
  onSubmit(){
    console.log("seelcted list"+this.selectedMonthlyResponseList)
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.invalid=false;
    for (var i = 0; i < this.selection.selected.length; i++) {
    let TotalAmountDue = parseFloat(this.selection.selected[i].totalAmountDue);
     if (TotalAmountDue === 0 || TotalAmountDue > 2000000) {
        this.invalid = true;
        this.amount = true;
      } 
    }
    if (numSelected < 1 || numSelected > 50) {
      this.contractSelected = false;
      this.tableLoaded = true;
      this.invalid = true;
      this.selectone = true;
     
    }else {
      this.accountSelected = true;
      this.selectone = false;
    }
    if(!this.invalid && this.selected && this.accountSelected){
    this.checkToggleSelectedForselection();
    this.monthlypaymentstep2 = true;
    this.monthlypayment = false;
    this.monthlypaymentstep1 = false;
    this.OnlinePaymentstep1 = false;
    }

    if(!this.selected){
      this.invalid =true;
      this.required = true;
    }else {
      this.required = false;
    }

    if(this.totalAmount > 2000000){
      this.invalid = true;
      this.amount = true;
    }
  }


 
convertToDecimal(element) {
  // Remove non-numeric characters (except dot and minus)
  let rawValue = element.totalAmountDue ? element.totalAmountDue.toString().replace(/[^0-9.-]+/g, '') : '';

  // Handle empty or invalid input
  let numericValue = parseFloat(rawValue);
  if (isNaN(numericValue) || rawValue === '') {
    numericValue = 0;
  }

  // Update the data source
  let index = this.dataSource.data.findIndex(
    (obj: any) => obj.agreementNumber === element.agreementNumber
  );

  // Format and assign back
  this.dataSource.data[index].totalAmountDue = this.addComma(numericValue.toFixed(2));

  // Recalculate totals
  this.calculateTotalAmount();
}

 restrictToTwoDecimals(event: KeyboardEvent, currentValue: string) {
  const input = event.target as HTMLInputElement;
  const key = event.key;

  // Allow navigation and editing keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return;
  }

  // Allow only digits and decimal point
  if (!/[0-9.]/.test(key)) {
    event.preventDefault();
    return;
  }

  const { selectionStart, selectionEnd, value } = input;
  const start = selectionStart ?? 0;
  const end = selectionEnd ?? 0;

  // Simulate what the input value would look like after this keypress
  const newValue = value.slice(0, start) + key + value.slice(end);

  // If there’s more than one dot, block
  if ((newValue.match(/\./g) || []).length > 1) {
    event.preventDefault();
    return;
  }

  // Check if there are more than 2 digits after the decimal
  const parts = newValue.split('.');
  if (parts.length === 2 && parts[1].length > 2) {
    event.preventDefault();
    return;
  }
}



  addComma(value: string): string {
    let [integerPart, decimalPart] = value.split('.');
  
    // Add commas to the integer part (before the decimal point)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Join the integer part with the decimal part (if any)
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  checkToggleSelectedForselection(){
    this.selectedMonthlyResponseList = [];
    for (var i = 0; i < this.selection.selected.length; i++) {
     this.selectedMonthlyResponseList = this.selection.selected;
     this.selectedMonthlyResponseList[i].paymentDate =  this.currentDate[this.selection.selected[i].agreementNumber].toString();
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
     this.selectedMonthlyResponseList = this.selection.selected;
     this.dataSource = new MatTableDataSource(this.selectedMonthlyResponseList);
    this.dataSource.paginator = null;
    this.dataSource.sort = this.sort;
    }
    
  }

subscriptionsList() {
  const request = {
    "customer_id": this.dtpayCustomerId,
  };

  this.auth.subscriptionsList(request).subscribe(res => {
    this.subscriptionList = res.data;

    if (res) {
      // Filter only ACTIVE subscriptions with payment_type === 'AGREEMENT'
      // AND where start_date !== end_date
      const filteredSubscriptions = this.subscriptionList.filter(sub => {
        const startDateStr: string | undefined = sub.execution_interval?.start_date;
        const endDateStr: string | undefined = sub.execution_interval?.end_date;

        return (
          sub.status === 'ACTIVE' &&
          sub.payment_settings?.metadata?.payment_type === 'AGREEMENT' &&
          !!startDateStr &&
          !!endDateStr &&
          startDateStr !== endDateStr
        );
      });

      // Collect unique agreement descriptions
      const subscriptionAgreements = new Set(
        filteredSubscriptions.map(sub => sub.line_items[0].description)
      );

      // Match agreements that already have subscriptions
      this.agreementsWithSubscription = this.MonthlyPaymentResponseList
        .filter(item => subscriptionAgreements.has(item.agreementNumber))
        .map(item => item.agreementNumber);

      // Show or hide the warning message
      if (this.agreementsWithSubscription.length > 0) {
        this.warningMessage = `Please Note: Our records indicate the highlighted accounts are already set up on a Recurring Payment Schedule.`;
        this.showWarning = true;
      } else {
        this.warningMessage = '';
        this.showWarning = false;
      }
    }

    console.log("getSubscriptions Response", this.subscriptionList);

    this.dataSource = new MatTableDataSource(this.MonthlyPaymentResponseList);

    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.rowCount = this.dataSource.filteredData.length;
    });
  });
}




  isHighlighted(agreementNumber: string): boolean {
  return this.agreementsWithSubscription.includes(agreementNumber);
  }


  // checkToggleSelectedForselection() {
  //   // 1. Get all selected items (across all pages)
  //   this.selectedMonthlyResponseList = this.selection.selected.map(item => {
  //     const updatedItem = { ...item };
  //     updatedItem.paymentDate = this.currentDate[item.agreementNumber]?.toString() || null;
  //     return updatedItem;
  //   });

  //   // 2. Show only selected items by replacing the dataSource's data
  //   this.dataSource = new MatTableDataSource(this.selectedMonthlyResponseList);

  //   // Disable paginator or reset it as you want — usually no need to paginate here
  //   this.dataSource.paginator = null;  // or remove paginator if you want to show all selected items in one list
  //   this.dataSource.sort = this.sort;
  // }

  back2step1(){
    window.location.reload();
    this.OnlinePaymentstep1 = true;
    this.monthlypayment = true;
    this.monthlypaymentstep1 = true;
    this.monthlypaymentstep2 = false;
    this.principalpaymentstep2 = false;
  }

  MonthlyPaymentAuthorize(){
    this.opendialog();
  }


  opendialog() {
    const dialogRef = this.dialog.open(AuthorizeDialogComponent, {
      data: { amount1: this.totalAmount, agentView: this.agentView }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        // ✅ STEP 3 FIRST
        this.isAmountEntered = true;
        this.OnlinePaymentstep1 = false;
        this.monthlypayment = false;
        this.monthlypaymentstep1 = false;
        this.monthlypaymentstep2 = false;
        this.monthlypaymentstep3 = true;
        this.principalpaymentstep2 = false;

        // ✅ THEN SHOW LOADER
        this.tableLoaded = false;

        let pendingCalls = 0;
        let completedCalls = 0;

        this.paymentPostedList = [];
        this.line_items = [];

        let todayLineItems: any[] = [];
        let positionCounter = 1;

        this.selection.selected.forEach((row) => {

          const rowDate = new Date(row.paymentDate);
          const rowDateStr = rowDate.getFullYear() + '-' +
            String(rowDate.getMonth() + 1).padStart(2, '0') + '-' +
            String(rowDate.getDate()).padStart(2, '0');

          const currentDateStr = this.currentDates.getFullYear() + '-' +
            String(this.currentDates.getMonth() + 1).padStart(2, '0') + '-' +
            String(this.currentDates.getDate()).padStart(2, '0');

          if (rowDateStr === currentDateStr) {

            const lineItem = new monthlypaymentRequestlist();
            lineItem.position = positionCounter++;
            lineItem.dollarAmount = parseFloat(row.totalAmountDue.replace(/[^0-9.-]+/g, ''));
            lineItem.alfa_agreement_number = row.agreementNumber;

            todayLineItems.push(lineItem);

          } else {

            this.line_items = [];

            const lineItem = new monthlypaymentRequestlist();
            lineItem.position = 1;
            lineItem.dollarAmount = parseFloat(row.totalAmountDue.replace(/[^0-9.-]+/g, ''));
            lineItem.alfa_agreement_number = row.agreementNumber;
            this.line_items.push(lineItem);

            this.exec_Interval = [];

            const executionIntervalObj = new executionInterval();
            executionIntervalObj.start_date = formatDate(row.paymentDate, 'yyyy-MM-dd', 'en-US');
            executionIntervalObj.end_date = formatDate(row.paymentDate, 'yyyy-MM-dd', 'en-US');
            executionIntervalObj.interval = "MONTHLY";
            this.exec_Interval.push(executionIntervalObj);

            const subscriptionRequest = {
              userId: this.ciamId,
              maskedAccountNumber: this.dtpayMaskedAccountNumber,
              customer_id: this.dtpayCustomerId,
              payment_type: "AGREEMENT",
              payment_settings: {
                payment_method: {
                  token: this.dtpayPaymentMethodToken,
                  type: "FIRST_PAYMENT"
                }
              },
              line_items: this.line_items,
              executionIntervalList: this.exec_Interval
            };

            pendingCalls++;

            this.auth.subscriptions(subscriptionRequest).subscribe(res => {

              if (res.statusMessage === "FAILURE") {
                this.failureError = true;
              }

              const postItem = {
                accountNumber: res[0].line_items[0].description,
                paymentAmount: res[0].line_items[0].alfa_agreement_number,
                paymentDate: res[0].execution_interval.start_date,
                reference: res[0].reference,
                status: res[0].status === "ACTIVE" ? "IN PROCESS" : res[0].status
              };

              this.paymentPostedList.push(postItem);

              completedCalls++;

              if (completedCalls === pendingCalls) {
                this.finishProcessing();
              }

            });
          }
        });

        // ✅ Orders API (for today's payments)
        if (todayLineItems.length > 0) {

          const orderRequest = {
            paymentLineItem: this.paymentLineItem,
            userId: this.ciamId,
            maskedAccountNumber: this.dtpayMaskedAccountNumber,
            customer_id: this.dtpayCustomerId,
            payment_type: "AGREEMENT",
            payment_settings: {
              payment_method: {
                token: this.dtpayPaymentMethodToken,
                type: "FIRST_PAYMENT"
              }
            },
            line_items: todayLineItems
          };

          pendingCalls++;

          this.auth.orders(orderRequest).subscribe(res => {

            if (res.statusMessage === "FAILURE") {
              this.failureError = true;
            }

           res.forEach(order => {
            order.line_items.forEach(item => {
              const postItem = {
                accountNumber: item.description,             
                paymentAmount: this.convertCentsToDollars(item.unit_price),
                paymentDate: order?.payment?.created_at,
                reference: order?.reference,
                status: order?.payment?.status === "COMPLETED" ? "COMPLETED" : order?.payment?.status === "FAILED" ? `FAILED (${order?.payment?.transactions?.[0]?.failure_reasons?.[0]?.message ?.split("responseMessage:")?.[1] ?.trim() || ""})`: "IN PROCESS"
              };
              this.paymentPostedList.push(postItem);
            });
          });
 

            completedCalls++;

            if (completedCalls === pendingCalls) {
              this.finishProcessing();
            }

          });
        }

        // Edge case: no API calls
        if (pendingCalls === 0) {
          this.finishProcessing();
        }
      }
    });
  }


  finishProcessing() {

    this.paymentdataSource = new MatTableDataSource(this.paymentPostedList);

    setTimeout(() => {
      this.paymentdataSource.paginator = this.paginator;
      this.paymentdataSource.sort = this.sort;
      this.rowCount = this.paymentdataSource.filteredData.length;
    });

    // ✅ HIDE LOADER
    this.tableLoaded = true;
  }

  convertCentsToDollars(cents: number | string): string {
    if (cents === null || cents === undefined || cents === '') {
      return '0.00';
    }
    const value = typeof cents === 'string' ? parseInt(cents, 10) : cents;
    if (isNaN(value)) {
      return '0.00';
    }
    return (value / 100).toFixed(2);
  }
  
  DownloadPdf() {
    const doc = new jsPDF({ format: 'a4' });
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
      }
      doc.setFont('Arial', 'bold');
      doc.text('Customer Name:', 15, 45);
      doc.setFont('Arial', 'normal');
      doc.text(this.customerName, 45, 45);

    var Header = [];
    Header = [
      ["Account Number", "Payment Amount", "Payment Date", "Transaction Id", "Status"]
    ];
  
   
    var rows = [];
    const head = Header;
    const data = this.paymentPostedList;
  
    // Loop through data and prepare rows
    data.forEach(element => {
      
     // Create a Date object from paymentDate (assuming it's in a valid string format)
    const paymentDate = new Date(element.paymentDate);
  
    // Extract month, day, and year
    const month = paymentDate.getMonth() + 1;  // getMonth() returns a zero-based index (0 = January, 11 = December)
    const day = paymentDate.getDate();
    const year = paymentDate.getFullYear();

    // Format the date as MM/dd/yyyy (pad month and day with zero if necessary)
    const formattedDate = `${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}/${year}`;
    
    var temp = [element.accountNumber, `$${parseFloat(element.paymentAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, element.paymentDate, element.reference, element.status];
      rows.push(temp);
    });
  
    // Table Configuration
    const marginTop = 40; // Top margin where the table starts
    const rowHeight = 10; // Height of each row in the table (adjust as needed)
    const headerHeight = 10; // Height of the header row
  
    // Add the table
    autoTable(doc,{
      head: head,
      body: rows,
      theme: 'grid',
      headStyles: { fillColor: [79, 77, 74] },
      margin: { top: marginTop }, // Start the table below the verbiage
    });
  
    // Calculate the total height of the table based on rows
    const tableHeight = (rows.length * rowHeight) + headerHeight; // Height of all rows plus the header
    const tableBottomY = marginTop + tableHeight;
  
    // Add footer text or additional verbiage below the table
    doc.setFontSize(12);
    
    // Wrap "Thank you for your payment." text
    const thankYouText = this.translate.instant('onlinepayment.auth');
    const maxWidth = 190; // Adjust this based on your document width
    const wrappedThankYouText = doc.splitTextToSize(thankYouText, maxWidth);
  
    // Add wrapped text
    let currentY = tableBottomY + 10; // Starting Y position for wrapped text
    wrappedThankYouText.forEach(line => {
      doc.text(line, 14, currentY);
      currentY += 6; // Adjust the line spacing as needed
    });
  
    // Add new paragraph with bold first word and checkbox
    const nextParagraphY = currentY + 10; // Position for next paragraph
  
    // Bold the first word in the paragraph
    doc.setFont("Arial", "bold");
    doc.text('Notice:', 14, nextParagraphY ); // First word in bold
  
    // Switch to regular font for the rest of the paragraph
    doc.setFont("Arial", "normal");
  
    // Text to wrap
    const paragraphText = 'Notice: The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.';
    
    // Split the text to fit the width
    const wrappedText = doc.splitTextToSize(paragraphText, maxWidth);
  
    // Add each line of wrapped text to the PDF
    let currentTextY = nextParagraphY + 5; // Starting Y position for the wrapped text
    wrappedText.forEach(line => {
      doc.text(line, 14, currentTextY);
      currentTextY += 6; // Adjust line spacing as needed
    });
  
    const checkboxX = 14;
    const checkboxY = currentTextY + 5;
    const checkboxSize = 5;

    // Draw the checkbox (square)
    doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

    // Draw a tick mark inside the checkbox
    doc.setLineWidth(0.5);
    doc.setDrawColor(0); // black tick
    // Draw the tick manually as two lines
    doc.line(checkboxX + 1, checkboxY + checkboxSize / 2, checkboxX + 2, checkboxY + checkboxSize - 1); // short stroke
    doc.line(checkboxX + 2, checkboxY + checkboxSize - 1, checkboxX + checkboxSize - 1, checkboxY + 1); // long stroke

    // Add label next to the checkbox
    doc.setFont("Arial", "normal");
    doc.text('I have read and accept the terms of the above Authorization Statement.', checkboxX + checkboxSize + 3, checkboxY + checkboxSize - 1);



    this.addHeaderFooters(doc)
    // Save the document as a PDF
    doc.save('Make a Payment Receipt.pdf');

  }

  DownloadPdfPayoff(){
    const doc = new jsPDF({ format: 'a4' });
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
      }
      doc.setFont('Arial', 'bold');
      doc.text('Customer Name:', 15, 45);
      doc.setFont('Arial', 'normal');
      doc.text(this.customerName, 45, 45);

    var Header = [];
    Header = [
      ["Account Number", "Payment Amount", "Payment Date", "Transaction Id", "Status"]
    ];
  
   
    var rows = [];
    const head = Header;
    const data = this.payoffResponseBeanList;
  
    // Loop through data and prepare rows
    data.forEach(element => {
    var temp = [element.contractNumber , `$${parseFloat(element.quoteAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, this.paymentDate, this.reference, this.status];
    rows.push(temp);
    });
  
    // Table Configuration
    const marginTop = 40; // Top margin where the table starts
    const rowHeight = 10; // Height of each row in the table (adjust as needed)
    const headerHeight = 10; // Height of the header row
  
    // Add the table
    autoTable(doc,{
      head: head,
      body: rows,
      theme: 'grid',
      headStyles: { fillColor: [79, 77, 74] },
      margin: { top: marginTop }, // Start the table below the verbiage
    });
  
    // Calculate the total height of the table based on rows
    const tableHeight = (rows.length * rowHeight) + headerHeight; // Height of all rows plus the header
    const tableBottomY = marginTop + tableHeight;
  
    // Add footer text or additional verbiage below the table
    doc.setFontSize(12);
    
    // Wrap "Thank you for your payment." text
    const thankYouText = this.translate.instant('onlinepayment.auth');
    const maxWidth = 190; // Adjust this based on your document width
    const wrappedThankYouText = doc.splitTextToSize(thankYouText, maxWidth);
  
    // Add wrapped text
    let currentY = tableBottomY + 10; // Starting Y position for wrapped text
    wrappedThankYouText.forEach(line => {
      doc.text(line, 14, currentY);
      currentY += 6; // Adjust the line spacing as needed
    });
  
    // Add new paragraph with bold first word and checkbox
    const nextParagraphY = currentY + 10; // Position for next paragraph
  
    // Bold the first word in the paragraph
    doc.setFont("Arial", "bold");
    doc.text('Notice:', 14, nextParagraphY ); // First word in bold
  
    // Switch to regular font for the rest of the paragraph
    doc.setFont("Arial", "normal");
  
    // Text to wrap
    const paragraphText = 'Notice: The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.';
    
    // Split the text to fit the width
    const wrappedText = doc.splitTextToSize(paragraphText, maxWidth);
  
    // Add each line of wrapped text to the PDF
    let currentTextY = nextParagraphY + 5; // Starting Y position for the wrapped text
    wrappedText.forEach(line => {
      doc.text(line, 14, currentTextY);
      currentTextY += 6; // Adjust line spacing as needed
    });
  
    const checkboxX = 14;
    const checkboxY = currentTextY + 5;
    const checkboxSize = 5;

    // Draw the checkbox (square)
    doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

    // Draw a tick mark inside the checkbox
    doc.setLineWidth(0.5);
    doc.setDrawColor(0); // black tick
    // Draw the tick manually as two lines
    doc.line(checkboxX + 1, checkboxY + checkboxSize / 2, checkboxX + 2, checkboxY + checkboxSize - 1); // short stroke
    doc.line(checkboxX + 2, checkboxY + checkboxSize - 1, checkboxX + checkboxSize - 1, checkboxY + 1); // long stroke

    // Add label next to the checkbox
    doc.setFont("Arial", "normal");
    doc.text('I have read and accept the terms of the above Authorization Statement.', checkboxX + checkboxSize + 3, checkboxY + checkboxSize - 1);
  

    this.addHeaderFooters(doc)
    // Save the document as a PDF
    doc.save('Payoff Receipt.pdf');
  }

  
  addHeaderFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.width;
    let translate = this.translate;

    doc.setFont('Arial', 'Normal');
    doc.setFontSize(8);


    for (var i = 1; i <= pageCount; i++) {

      //Pagination
      doc.setPage(i);
      doc.text('Page ' + String(i) + ' of ' + String(pageCount),
        pageWidth / 2, 279, {
        align: 'center',
      }
      );

      if (i <= 2 || i == pageCount) {
        // sign  
        doc.text(translate.instant('Payoff.payofffooter_line1'), pageWidth - 72, 270, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line2'), pageWidth - 72, 274, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line3'), pageWidth - 72, 278, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line4'), pageWidth - 72, 282, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line5'), pageWidth - 72, 286, { align: 'left' }
        );
      }
    }

  };
  
  BacktoDashBoard(){
    this._window.nativeWindow.location.href = '/home/dashboard';
  }


  applyFilterAcc(input: string) {
    this.dataSource.filterPredicate = (data: monthlypaymentResponseList, f: string) =>
      !f ||
      data.agreementNumber.toLowerCase().includes(f) 
    input = input.trim(); // Remove whitespace
    input = input.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = input;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;

  }
  
dueDateControl = new FormControl('', [
  this.invalidDateValidator
]);

invalidDateValidator(control: FormControl) {
  if (!control.value) return null;

  const value = control.value;

  // If it's a Date object (from datepicker)
  if (value instanceof Date && !isNaN(value.getTime())) {
    return null;
  }

  // If user manually typed string
  if (typeof value === 'string') {
    const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (!regex.test(value)) {
      return { invalidDate: true };
    }

    const parts = value.split('/');
    const month = +parts[0] - 1;
    const day = +parts[1];
    const year = +parts[2];

    const date = new Date(year, month, day);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
    )
      ? null
      : { invalidDate: true };
  }

  return { invalidDate: true };
}

  applyFilterDate(filterValue: string) {
    this.pipe = new DatePipe('en-US');
    if (filterValue) {
      filterValue = formatDate(new Date(filterValue), 'MM/dd/yyyy', 'en-US');
    }
    const defaultPredicate = this.dataSource.filterPredicate;
    this.dataSource.filterPredicate = (data, filter) => {
      // If no filter is applied, show all rows
      if (!filter) {
        return true;
      }
      const formatted = this.pipe.transform(data.currentDueDate, 'MM/dd/yyyy');
    
      return formatted?.indexOf(filter) >= 0 || defaultPredicate(data, filter);
    };
    this.dataSource.filter = filterValue ? filterValue.trim().toLowerCase() : '';
    if (!filterValue) {
      this.dataSource.filter = ''; // Reset filter to show all data
    }
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  applyFilterCurrentAmountDue(input1: string) {
    if (!input1) {
      this.dataSource.filter = ''; // Reset the filter to show all data
      this.rowCount = this.dataSource.filteredData.length;
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
      return; 
    }
    this.dataSource.filterPredicate = (data: monthlypaymentResponseList, f: string) => {
      const formattedAmount = data.totalAmountDue.replace(/,/g, ''); 
      const filterValue = f ? f.replace(/,/g, '') : ''; 
      return !f || formattedAmount.includes(filterValue);
    };
    input1 = input1.trim(); // Remove  whitespace
    input1 = input1.toLowerCase(); 
  
    this.dataSource.filter = input1; // Apply the filter
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }
  


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;    
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

}

@Component({
    selector: 'dialog-authorizePopup',
    imports: [
        MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule, MatSortModule,
        MatDialogContent, MatDialogActions],
    templateUrl: 'authorizePopup.component.html'
})
export class AuthorizeDialogComponent {

  amount1: string;
  agentView: boolean = false;
  thirdParty: string;
  wasatch: boolean = false;
  paymentLineItem: string;

  constructor(
    public dialogRef: MatDialogRef<OnlinepaymentComponent>, public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any  
  ) { 
    this.amount1 = parseFloat(data.amount1).toFixed(2);
    this.agentView = data.agentView;
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.paymentLineItem = sessionStorage.getItem('paymentLineItem');
    if(this.paymentLineItem == "Y"){
      this.wasatch = true;
    }else{
      this.wasatch = false;
    }
    console.log("amount in dialog: "+this.amount1);
    console.log("agentView in dialog: "+this.agentView);
    console.log("thirdParty in dialog: "+this.thirdParty);
  }

 
  onOk() {
    this.dialogRef.close(true);  
  }

 
  onCancel() {
    this.dialogRef.close(false); 
  }


}











